import { useEffect, useState } from "react";
import { makeStyles } from "tss-react/mui";
import { CircularProgress } from "@mui/material";
import AuthService, { ConnectionState } from "services/AuthService";
import { StorageUtils } from "services/UtilsService";
import SignalrService from "services/SignalrService";
import { getCachedData } from "api/Cache";
import EventsEmitter from "events/EventsEmitter";
import { Switcher } from "./";
import { defaultProject, defaultProjectName } from "constants/ui";
import themeCfg from "config/theme.json";
import commonStyles, { backgroundColor, drawerWidth, headerHeight } from "styles/common";

const useStyles = makeStyles()((theme: any) => ({
    mainRoot: {
        display: "flex",
        flexDirection: "column",
        position: "fixed",
        margin: 0,
        width: "100%",
        height: "100%",
        "& .MuiPaper-root": {
            //boxShadow : 'none'
            backgroundColor: 'unset !important'
        }
    },
    top: {
        position: "relative",
        width: "100%",
        height: headerHeight,
        display: "inline-block",
        
    },
    appBar: {
        boxShadow: "none",
        zIndex: theme.zIndex.drawer + 1,
        transition: theme.transitions.create(["width", "margin"], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        position: "relative",
        display: "flex",
        flexDirection: "row",
        height: headerHeight,
        alignItems: "center",
    },
    appBarShift: {
        marginLeft: drawerWidth,
        width: `calc(100% - ${drawerWidth}px)`,
        transition: theme.transitions.create(["width", "margin"], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    toolbar: {
        height: "100%",
        width: "100%",
        backgroundColor: themeCfg.mainTopColor,
    },
    hamburger: {
        width: 55,
        minWidth: 55,
        minHeight: 40,
    },
    menuButton: {
        marginLeft: 20,
        marginRight: theme.spacing(2),
    },
    hide: {
        display: "none",
    },
    title: {
        flexGrow: 1,
    },
    rightToolbar: {
        // height: panelHeight,
        width: '100%',
        paddingRight: 20,
        display: "inline-flex",
        alignItems: "center",
    },
    bottom: {
        display: "inline-flex",
        width: "100%",
        height: "100%",
        position: "relative",
    },
    main: {
        width: "100%",
        height: "100%",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
    },
    signIn: {
        width: "100%",
        height: "100%",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: backgroundColor,
    },
    CircularProgress: {
        position: "absolute",
        left: 0,
        right: 0,
        top: 0,
        bottom: 0,
        margin: 'auto auto'
    },
}));

export default function Main(props: { component: any }) {
    const { component } = props;
    const { classes } = useStyles();
    const { classes: common } = commonStyles();
    const data: any = getCachedData();
    const projects: any = data["projects"];

    const [open, setOpen] = useState(true);
    const [filter, setFilter] = useState(StorageUtils.loadFromSessionStorage("filter") || defaultProject);
    const [projectName, setProjectName] = useState(defaultProjectName);

    useEffect(() => {
        if (filter !== "all" && filter !== defaultProject && Object.values(projects).length > 0) {
            if (filter.split(",").length > 1) {
                setProjectName("Multi");
            } else {
                if (projects[filter]) {
                    setProjectName(projects[filter].name);
                } else {
                    setFilter("all");
                    setProjectName("All");
                    StorageUtils.saveToSessionStorage("filter", defaultProject);
                }
            }
        } else {
            setProjectName("All");
        }
    }, [data.loaded, filter, projects]);

    useEffect(() => {
        const handleSignalrProjects = () => {
            console.log("filter:", filter);
            if (filter !== "all") {
                //SignalrService.cleanSubscription();
                SignalrService.subscribeToProject(filter);
            } else if (filter === "all" || filter === defaultProject) {
                Object.keys(projects).forEach((projectId: string) => {
                    SignalrService.subscribeToProject(projectId);
                });
            } else if (Array.isArray(filter)) {
                const curfilter: any = filter;
                if (curfilter.split(",").length > 1) {
                    curfilter.split(",").forEach((projectId: string) => {
                        SignalrService.subscribeToProject(projectId);
                    });
                }
            }
        };
        EventsEmitter.on("signalr", handleSignalrProjects);
        handleSignalrProjects();
        return () => {
            EventsEmitter.removeEventListener("signalr", handleSignalrProjects);
        };
    }, [filter, projects]);

    return (
        <>
            {component ? (
                component
            ) : (AuthService.needLogin || AuthService.connectionState === ConnectionState.ERROR) &&
                AuthService.accessToken === "" ? (
                AuthService.connectionState === ConnectionState.NEEDS_LOGIN ? (
                    <div className={classes.signIn}>Please sign in</div>
                ) : AuthService.connectionState === ConnectionState.ERROR ? (
                    <div className={classes.signIn}>Failed Login, Please sign in</div>
                ) : (
                    <CircularProgress className={classes.CircularProgress} />
                )
            ) : (
                <Switcher />
            )}
        </>
    );
}